import axiosClient from "./axiosClient";
import { staffAssociatedInfo } from "../types/staff.types";
import { BrokerInfo } from "../types/livechat.types";

export const getStaffList = () => {
  return axiosClient.get<any, staffAssociatedInfo[]>("/user-associate/staffList");
};

export const getStaffInfo = (staffCode: string) => {
  const url = `/brokers/staffInfoByCode?code=${staffCode}`;
  return axiosClient.get<any, BrokerInfo>(url);
};

export const getStaffInfoByReferralCode = (referralCode: string) => {
  const url = `/brokers/referral?code=${referralCode}`;
  return axiosClient.get(url);
};
